/**
 * Client service for Hospital People & Shifts.
 * R39 C6.a (plan docs/plans/sector-operations.md §2 SO-P252, H§4).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'
import type { OpsPersonRef } from '../types/ops'

export interface AcknowledgeOnCallInput {
  workspaceId: string
  rosterId: string
  version: number
  dayKey: string
  kind: 'ON_CALL_PRIMARY' | 'ON_CALL_BACKUP'
  opId: string
}

export interface AcknowledgeOnCallResult {
  success: true
  ackId: string
  replayed?: boolean
}

export interface GetOnCallBoardInput {
  workspaceId: string
  placeId: string
  fromDay: string
  days: number
}

export interface OnCallSlotStatus {
  rosterId?: string
  version?: number
  personRef: OpsPersonRef
  displayName?: string
  dutyRoleKey: string
  kind: 'ON_CALL_PRIMARY' | 'ON_CALL_BACKUP'
  ackState: 'ACKED' | 'NOT_ACKED'
  ackedAt: string | null
  carriedForward?: boolean
}

export interface OnCallDayUnit {
  dayKey: string
  primary: OnCallSlotStatus | null
  backup: OnCallSlotStatus | null
}

export interface OnCallUnitBoard {
  placeId: string
  placeName: string
  days: OnCallDayUnit[]
}

export interface GetOnCallBoardResult {
  placeId: string
  fromDay: string
  days: number
  units: OnCallUnitBoard[]
}

export async function acknowledgeOnCall(
  input: AcknowledgeOnCallInput,
): Promise<AcknowledgeOnCallResult> {
  return callable<AcknowledgeOnCallInput, AcknowledgeOnCallResult>('acknowledgeOnCall', input)
}

export async function getOnCallBoard(
  input: GetOnCallBoardInput,
): Promise<GetOnCallBoardResult> {
  return callable<GetOnCallBoardInput, GetOnCallBoardResult>('getOnCallBoard', input)
}

export interface ListMyOnCallSlotsInput {
  workspaceId: string
  fromDay: string
  days: number
}

export interface MyOnCallSlot {
  rosterId: string
  version: number
  placeId: string
  placeName: string
  dayKey: string
  kind: 'ON_CALL_PRIMARY' | 'ON_CALL_BACKUP'
  dutyRoleKey?: string
  ackState: 'ACKED' | 'NOT_ACKED'
  ackedAt: string | null
  carriedForward?: boolean
}

export interface ListMyOnCallSlotsResult {
  slots: MyOnCallSlot[]
}

export async function listMyOnCallSlots(
  input: ListMyOnCallSlotsInput,
): Promise<ListMyOnCallSlotsResult> {
  return callable<ListMyOnCallSlotsInput, ListMyOnCallSlotsResult>('listMyOnCallSlots', input)
}
